import React from "react";
import { Box, Button, CircularProgress, IconButton } from "@mui/material";
import { ChevronLeft } from "@mui/icons-material";
import { ACCENT } from "../BusinessOnboard.constant";

interface IStepFooterProps {
  primaryLabel: string;
  onPrimary?: () => void;
  /** When set, the primary button submits the form instead of using onPrimary. */
  primaryType?: "button" | "submit";
  onBack?: () => void;
  showBack?: boolean;
  loading?: boolean;
  disabled?: boolean;
}

/** Circular back button + full-width red primary CTA, separated by a divider. */
export const StepFooter: React.FC<IStepFooterProps> = ({
  primaryLabel,
  onPrimary,
  primaryType = "button",
  onBack,
  showBack = true,
  loading = false,
  disabled = false,
}) => (
  <Box
    sx={{
      mt: 3,
      pt: 2.5,
      borderTop: "1px solid",
      borderColor: "grey.200",
      display: "flex",
      alignItems: "center",
      gap: 2,
    }}
  >
    {showBack && (
      <IconButton
        onClick={onBack}
        disabled={loading}
        sx={{
          width: 46,
          height: 46,
          flexShrink: 0,
          border: "1px solid",
          borderColor: "grey.300",
          color: "text.secondary",
          "&:hover": { borderColor: "grey.400", backgroundColor: "grey.50" },
        }}
      >
        <ChevronLeft />
      </IconButton>
    )}

    <Button
      type={primaryType}
      onClick={primaryType === "submit" ? undefined : onPrimary}
      disabled={disabled || loading}
      fullWidth
      sx={{
        py: 1.4,
        borderRadius: "12px",
        fontSize: "1rem",
        fontWeight: 700,
        textTransform: "none",
        color: "#fff",
        backgroundColor: ACCENT.main,
        boxShadow: "none",
        "&:hover": { backgroundColor: ACCENT.dark, boxShadow: "none" },
        "&.Mui-disabled": {
          backgroundColor: ACCENT.main,
          opacity: 0.55,
          color: "#fff",
        },
      }}
    >
      {loading ? (
        <CircularProgress size={20} sx={{ color: "#fff" }} />
      ) : (
        primaryLabel
      )}
    </Button>
  </Box>
);
